import { Event } from "../../../base/common/events";
import { createDecorator } from "../../instantiation/common/registry";
import { IDisposable } from "../../../base/common/lifecycle";


export const INotificationService = createDecorator<INotificationService>('notificationService');

export interface INotificationService {

    readonly _serviceBrand: undefined;

    readonly onDidChange: Event<void>;

    get notifications(): readonly INotification[];

    success(message: string, opts?: NotificationOptions): IDisposable;
    info(message: string, opts?: NotificationOptions): IDisposable;
    warn(message: string, opts?: NotificationOptions): IDisposable;
    error(message: string, opts?: NotificationOptions): IDisposable;

    showNotification(options: ShowNotificationOptions): IDisposable;

    dismissNotification(id: string): void;
}

export type NotificationType = 'info' | 'warning' | 'error' | 'success' | 'tutorial';

export type NotificationCoordinates = { x: number; y: number; };

export interface ShowNotificationOptions {
    // @TODO: add window ID so we can show notifications in specific windows
    
    /** Unique identifier for the notification. If a notification with this key is already displayed it will be replaced */
    key?: string;

    message: string;

    /** How the notification should be displayed */
    type?: NotificationType;
    icon?: string;
    /** Duration in milliseconds after which the notification should automatically disappear. */
    duration?: number;
    position?: "cursor" | "toast" | "xy";
    positionXY?: NotificationCoordinates;
    /** Invoked when the notification body is clicked (e.g. open a dialog). */
    onClick?: () => void;
}

export type NotificationOptions = Omit<ShowNotificationOptions, 'message' | 'type'>;

export interface INotification extends IDisposable {
    readonly onDidChange: Event<void>;
    readonly id: string;

    message: string;

    type: NotificationType;
    key?: string;

    icon?: string;
    duration?: number;
    position?: "cursor" | "toast" | "xy";
    positionXY?: { x: number; y: number; };

    onClick?: () => void;
    dismiss?: () => void;

    /**
     * Indicates that the notification is in the process of closing
     */
    closing?: boolean;

}

export interface INotificationWithPosition extends INotification {
    readonly position: "xy";
    readonly positionCoordinates: { x: number; y: number; };
}

export function isNotificationWithPosition(notification: INotification): notification is INotificationWithPosition {
    return notification.positionXY != undefined && "x" in notification.positionXY && "y" in notification.positionXY && notification.position === "xy";
}